export default __webpack_public_path__ + "08d6bcf30b40d50bc0759389bab74ae4.png";